import { useEffect, useState } from "react";
import { getPublicActivities } from "@/lib/webContentApi";
import { ActivityItem } from "@/lib/webContentTypes";

export default function ActivitiesPage() {
  const [active, setActive] = useState<ActivityItem[]>([]);

  useEffect(() => {
    getPublicActivities()
      .then((items) => setActive(items.filter((item) => item.active)))
      .catch(() => setActive([]));
  }, []);

  return (
    <main className="pt-24 pb-20 min-h-screen bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <span className="text-emerald-600 text-sm font-semibold uppercase tracking-wider">Agenda comunitaria</span>
          <h1
            className="text-4xl md:text-5xl font-extrabold text-sky-900 mt-2 mb-4"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Actividades y Eventos
          </h1>
          <p className="text-slate-500 text-lg max-w-xl mx-auto">
            Reuniones, operativos en terreno, talleres y eventos comunitarios del APR.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {active.map((activity) => {
            const d = new Date(activity.date);
            const day = d.toLocaleDateString("es-CL", { day: "2-digit" });
            const month = d.toLocaleDateString("es-CL", { month: "long" });
            const year = d.getFullYear();

            return (
              <div
                key={activity.id}
                className="flex flex-col md:flex-row gap-0 rounded-2xl overflow-hidden border border-slate-100 hover:border-sky-200 hover:-translate-y-1 transition-all duration-300 bg-white"
              >
                <div className="w-full md:w-48 h-48 md:h-auto flex-shrink-0 overflow-hidden">
                  <img
                    src={activity.imageUrl}
                    alt={activity.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6 flex flex-col justify-between flex-1">
                  <div>
                    <div className="flex items-center gap-3 mb-3">
                      <div className="flex flex-col items-center justify-center w-14 h-14 rounded-xl bg-sky-100 flex-shrink-0">
                        <span className="text-2xl font-extrabold text-sky-700 leading-none">{day}</span>
                        <span className="text-xs font-bold text-sky-500 leading-none mt-0.5 capitalize">{month.slice(0, 3).toUpperCase()}</span>
                      </div>
                      <div>
                        <h2 className="font-bold text-sky-900 text-lg leading-snug">{activity.title}</h2>
                        <span className="text-xs text-slate-400">{month} {year}</span>
                      </div>
                    </div>
                    <p className="text-slate-600 text-sm leading-relaxed">{activity.summary || activity.content}</p>
                  </div>
                  <div className="flex items-center gap-1.5 text-slate-400 text-sm mt-4">
                    <i className="ri-map-pin-line text-sky-400 text-base"></i>
                    <span>{activity.location}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {active.length === 0 && (
          <div className="text-center py-20 text-slate-400">
            <i className="ri-calendar-line text-5xl mb-4 block"></i>
            <p>No hay actividades programadas por el momento.</p>
          </div>
        )}
      </div>
    </main>
  );
}
